import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import Hidden from '@material-ui/core/Hidden';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100vw',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      },
  },
  progress: {
    marginTop: '15vw'
  },
}));

export const Progress = (props) => {
  const classes = useStyles();
  const matches = useMediaQuery('(min-width:600px)');
  return (
    <div className={classes.root}>
      <CustomizedLiner />
      <Message component='div'>{props.message}</Message>
    </div>
  );
}

const Message = styled(Typography)`
margin-top: 12.5vw;
margin-bottom: 15vw;
font-size: 20px;
font-weight:700;
@media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){
  margin-top:100px;
  margin-bottom: 50px;
  font-size: 28px;
   }
`;

const StyledProgress = styled(CircularProgress).attrs({
})`
@media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){

 }
`

const CustomizedLiner = styled(LinearProgress)`
width:100vw;
margin-top: 20px
`
